import React from 'react';
import PropTypes from 'prop-types';

import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Trans } from 'react-i18next';

/**
 * Component displaying reporting section with title and text, and which is always opened. There is no collapsible panel.
 * @param {Component properties} props
 */
export default function ReportsOpenTextSection(props) {
  const useStyles = makeStyles(theme => ({
    sectionTitle: {
      fontFamily: 'Museo-500',
      fontSize: props.fontTitleSize ? props.fontTitleSize : 16,
      fontWeight: props.fontWeight ? props.fontWeight : 'normal',
      lineHeight: 1.19,
      color: props.fontColor ? props.fontColor : '#262626',
      marginLeft: props.leftImage && 10,
    },
    sectionTitleSecondary: {
      fontFamily: 'MuseoSans-900',
      fontSize: props.fontTitleSize ? props.fontTitleSize : 18,
      fontWeight: props.fontWeight ? props.fontWeight : 'normal',
      lineHeight: 1.19,
      color: props.fontColor ? props.fontColor : '#262626',
    },
    sectionText: {
      fontFamily: 'MuseoSans',
      fontSize: props.sectionFontSize ? props.sectionFontSize : 14,
      fontWeight: 'normal',
      fontStretch: 'normal',
      lineHeight: 1.21,
      color: props.color ? props.color : '#222222',
    },
  }));

  const classes = useStyles();

  return (
    <>
      <Box
        px={'20px'}
        display="flex"
        justifyContent={props.leftImage ? 'flex-start' : 'center'}
        alignItems="center"
      >
        {props.leftImage && (
          <img
            src={props.leftImage}
            height={props.leftImgHeight ? props.leftImgHeight : '60px'}
            alt="icon"
          />
        )}
        <span
          className={
            props.sectionTitleSecondary
              ? classes.sectionTitleSecondary
              : classes.sectionTitle
          }
        >
          {props.title}
        </span>
        {props.rightImage && (
          <img src={props.rightImage} height={'83px'} alt="icon" />
        )}
      </Box>

      {props.paragraphsKeys && props.paragraphsKeys.length > 0 && (
        <Box
          px={'20px'}
          paddingTop={'20px'}
          display="column"
          justifyContent="center"
          alignItems="center"
        >
          {props.paragraphsKeys.map((paragraphKey, ix) => {
            return (
              <Typography
                key={ix}
                style={{
                  fontFamily: 'MuseoSans',
                  fontSize: props.isDesktop ? '18px' : '16px',
                  fontWeight: 300,
                  lineHeight: 1.33,
                  paddingBottom: '20px',
                }}
              >
                <Trans i18nKey={paragraphKey} />
              </Typography>
            );
          })}
        </Box>
      )}

      {props.contentItems && props.contentItems.length > 0 && (
        <Box
          px={'20px'}
          display="column"
          justifyContent="center"
          alignItems="center"
        >
          {props.contentItems.map((item, ix) => {
            return (
              <React.Fragment key={ix}>
                <p
                  className={classes.sectionText}
                  key={ix}
                  style={{
                    wordWrap: 'break-word',
                    overflowWrap: 'break-word',
                    wordBreak: 'break-word',
                  }}
                >
                  {item}
                </p>
              </React.Fragment>
            );
          })}
        </Box>
      )}
    </>
  );
}

ReportsOpenTextSection.propTypes = {
  /**
   * Section title.
   */
  title: PropTypes.string.isRequired,

  /**
   * Lokalise keys for texts to be displayed as paragraphs inside section.
   */
  paragraphsKeys: PropTypes.arrayOf(PropTypes.string),

  /**
   * Content items to be displayed.
   */
  contentItems: PropTypes.arrayOf(PropTypes.object),
};
